/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InterestLevel {
    '_40' = 40,
    '_50' = 50,
    '_60' = 60,
    '_70' = 70,
    '_75' = 75,
    '_80' = 80,
    '_90' = 90,
    '_100' = 100,
    '_110' = 110,
    '_200' = 200,
    '_300' = 300,
}
